import moment from 'moment';
import { isJsonStr, dateFormat } from '@/utils';
export default {
  isAcceptancePOC(formType, formOID) {
    //console.log('isAcceptancePOC', formType, formOID);
    return (
      formType === 2002 &&
      ['ad1243aa-9ec3-4eb3-93a2-3b356fff02e8', 'd46ac071-4af1-4490-80bc-9819ee3c610a'].indexOf(formOID) > -1
    );
  },
  /**
   * @description:
   * @param {*} field 控件信息
   * @param {*} date 要处理的日期值
   * @return {*}
   *  res 对应日期格式转utc后的日期值
   *  showMode 配置的日期展示模式
   *  formatDate 按配置显示的日期内容
   */
  handleCom_Date(field = {}, date) {
    const fieldContent = isJsonStr(field.fieldContent) ? JSON.parse(field.fieldContent) : {};
    const showMode = (fieldContent && fieldContent.showMode) || 'YYYY-MM-DD';
    let res, formatDate;
    switch (showMode) {
      case 'YYYY':
        res =
          date && moment(date)._isValid
            ? moment(date).set('month', 0).startOf('month').utc().format()
            : date || undefined;
        formatDate = date && moment(date)._isValid ? dateFormat(date, 'yyyy') : date || '';
        break;
      case 'YYYY-MM':
        res = date && moment(date)._isValid ? moment(date).startOf('month').utc().format() : date || undefined;
        formatDate = date && moment(date)._isValid ? dateFormat(date, 'yyyy-MM') : date || '';
        break;
      case 'YYYY-MM-DD':
        res =
          date && moment(date)._isValid ? moment(moment(date).format('YYYY-MM-DD')).utc().format() : date || undefined;
        formatDate = date && moment(date)._isValid ? dateFormat(date, 'yyyy-MM-dd') : date || '';
        break;
    }
    return { showMode, res, formatDate };
  },
};
